import * as React from "react";
import { Link } from "gatsby";
import HeaderMenu from "../components/HeaderMenu/HeaderMenu";
import Typewriter from 'typewriter-effect';
import { withLayout, LayoutProps, menuItems } from "../components/Layout";
import YouTube from 'react-youtube';
import {
  Segment,
  Container,
  Header,
} from "semantic-ui-react";

const opts = {
  playerVars: {
    autoplay: 1,
  },
};

const _onReady = (event) => {
  event.target.playVideo();
}

const _onInit = (typewriter) => {
  typewriter.typeString('Hello Satan!')
    .pauseFor(1500)
    .typeString(' <br /> Welcome Back!')
    .start();
}

const IndexPage = (props: LayoutProps) =>
  <div>
    <Segment vertical inverted textAlign="center" className="masthead">
      <HeaderMenu
        Link={Link} 
        pathname={props.location.pathname} 
        items={menuItems} 
        inverted
      />
      <Container text>
        <Header inverted as="h1" color="red">
          <Typewriter onInit={_onInit} />
        </Header>
      </Container>
    </Segment>
    <Segment vertical textAlign="center">
      <Container>
        <YouTube 
          videoId="oHg5SJYRHA0" 
          opts={opts} 
          onReady={_onReady} 
        />
      </Container>
    </Segment>
  </div>;

export default withLayout(IndexPage);
